import app from 'app'
import routes from 'routes/manager'
import reducers from 'reducers/index.manager'

app({
	appName: 'manager'
  , routes
  , routesPath: 'routes/manager' // for HMR
  , reducers
  , reducersPath: 'reducers/index.manager' // for HMR
})



// WEBPACK FOOTER //
// ./src/manager.js